import React from 'react'
import MediaContainer from '../../../../../widgets/Layout/MediaContainer'
import ReadingTime from '../../../../../widgets/ReadingTime'
import ListImage from '../../../../../legacy_components/Image/Rendition/List'
import PropTypes from 'prop-types'
import { getLocales } from '../../../../../utilities/locales'
import styles from './Cover.module.css'

const Cover = ({
  article,
  lazy,
  size = 'default',
  variant = 'default',
  locale,
}) =>
  <div className={ `${styles.wrapper} ${ size === 'large' ? styles['size-large'] : ''}` }>
    <MediaContainer variant={ variant }>
      <ListImage
        src={ article.image.src }
        alt={ article.image.alt }
        lazy={ lazy }
        size={ size }
      />
    </MediaContainer>
    <div className={ styles['reading-time'] }>
      <ReadingTime time={ article.readingTime } locale={ locale } />
    </div>
    { article.coverStrip
      ? <div className={ `${styles.strip} ${ size === 'large' ? styles[size] : ''}` }>
        { article.coverStrip }
      </div>
      : null
    }
  </div>

Cover.propTypes = {
  article: PropTypes.object.isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
  lazy: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['squared', 'default']),
  size: PropTypes.oneOf(['large', 'default']),
}

const Placeholder = ({ variant, size = 'default' }) =>
  <div className={ `article-cover-wrapper placeholder size-${ size }` }>
    <MediaContainer variant={ variant } />
  </div>

Cover.Placeholder = Placeholder

export default Cover
